import swal from "sweetalert";

/**
 * Shared confirmation dialogs for the menu catalog (menus, categories,
 * subcategories, products, choices, items). Both resolve to `true` when the
 * user confirms and `false` when they cancel or dismiss the dialog.
 */

/** Ask before archiving. `textKey` is the i18n key describing what gets archived. */
export async function confirmArchive(t, textKey) {
  const ok = await swal({
    title: t("areYouSure"),
    text: t(textKey),
    icon: "warning",
    buttons: [t("cancel"), t("archive")],
    dangerMode: true,
  });
  return Boolean(ok);
}

/**
 * Ask before persisting a drag-and-drop reorder.
 * Styled to match the menu-tree cards (see `.swal-reorder` in jsx/index.css).
 */
export async function confirmReorder(t) {
  const ok = await swal({
    title: t("reorderConfirmTitle"),
    text: t("reorderConfirmText"),
    className: "swal-reorder",
    buttons: {
      cancel: { text: t("cancel"), value: false, visible: true, className: "swal-reorder__cancel" },
      confirm: { text: t("reorderConfirmAction"), value: true, className: "swal-reorder__confirm" },
    },
  });
  return Boolean(ok);
}
